module.exports = __webpack_public_path__ + "img/jingmi2_5kg_2.f03539cf.jpg";